import { Injectable } from '@angular/core';

// The names of weather in count from 0 to 12 as we receive from Data provider. For day time
const weatherTypeTranslationsArr: string[] = [
  'Sonnig',
  'Neblig',
  'Neblig',
  'Wolkig',
  'Bewölkt',
  'Regenschauer',
  'Regnerisch',
  'Gewittrig',
  'Stark bewölkt',
  'Schnee',
  'Schneeschauer',
  'Schneeregen',
  'Schneeregen',
];

// The names of weather in count from 0 to 12 as we receive from Data provider. For night time
const weatherTypeTranslationsArrNight: string[] = [
  'Heiter', // Only first item is different
  ...weatherTypeTranslationsArr.slice(1),
];

@Injectable({
  providedIn: 'root',
})
export class WeatherTranslationService {
  constructor() {}

  /**
   * As soon as API returns a weather type by numbers 0-6, this helper converts it to a human readable string
   */
  public getWeatherTypeName = (symbol: number, daytime: 'night' | 'day' = 'day'): string =>
    daytime === 'night' ? weatherTypeTranslationsArrNight[Number(symbol)] : weatherTypeTranslationsArr[Number(symbol)];

  /**
   * Generates the wind direction icon rotation by provided wind direction
   */
  public getWindIconRotateByWindDirection(windDirection: string): number {
    switch (windDirection) {
      case 'NW':
        return 315;
      case 'W':
        return 270;
      case 'SW':
        return 225;
      case 'S':
        return 180;
      case 'SO':
        return 135;
      case 'O':
        return 90;
      case 'NO':
        return 45;
      default:
        return 0;
    }
  }
}
